<template>
  <bulk-edit-page
    :aspect-menu-items="aspectMenuItems"
    :errors="errors"
    :log-entries="null"
    :meta="meta"
    :model="model"
    :resource-type="resourceType"
    :toasts="toasts"
  >
  </bulk-edit-page>
</template>

<script>
import BulkEditPage from '@kanrisha/Pages/Models/BulkEdit';

export default {
  components: {
    BulkEditPage,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    resourceType: { type: String, default: '' },
    meta: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
